/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:09:02
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-19 17:41:57
 */
import req from "@/utils/request";

//  get 请求示列
export const findColumnManuscriptTotal = (params) => req.post("/dataCenter-service/m/webOverview/findColumnManuscriptTotal", params);
export const findManagementTotal = (params) => req.post("/dataCenter-service/m/webOverview/findManagementTotal", params);
export const findSiteColumnTotal = (params) => req.post("/dataCenter-service/m/webOverview/findSiteColumnTotal", params);
export const findUserTotal = (params) => req.post("/dataCenter-service/m/webOverview/findUserTotal", params);
export const findSiteTrendsColumnManuscriptTotal = (params) => req.post("/dataCenter-service/m/webOverview/findSiteTrendsColumnManuscriptTotal", params);
export const siteAccess = (params) => req.post("/dataCenter-service/m/webOverview/siteAccess", params);
export const wordCloudAnalysis = (params) => req.post("/dataCenter-service/m/webOverview/wordCloudAnalysis", params);
export const regionalDistribution = (params) => req.post("/dataCenter-service/m/webOverview/regionalDistribution", params);
export const list = (params) => req.post("/site-service/m/site/list", params);
export const urlTop = (params) => req.post("/dataCenter-service/m/webOverview/urlTop", params);
export const manuscriptTop = (params) => req.post("/dataCenter-service/m/webOverview/manuscriptTop", params);
